import React, { useState } from "react";
import { Box, Button, Stack, Step, StepLabel, Stepper, Typography } from "@mui/material";
import MasterGeneralInformation from "./MasterGeneralInformation/MasterGeneralInformation";
import ApplicableDate from "./ApplicableDateSection/ApplicableDate";
import DiscountValueSection from "./DiscountValueSection/DiscountValueSection";
import ProductSelectionSection from "./ProductSelectionSection/ProductSelectionSection";
import StoreAvailabilitySection from "./StoreAvailabilitySection/StoreAvailabilitySection";

const steps = ["General Information", "Applicable Date", "Store Availability", "Discount Value", "Product Selection"];

function DiscountMaster() {
	const [value, setValue] = useState({});
	const [activeStep, setActiveStep] = useState(0);

	const handleNext = () => setActiveStep((prev) => prev + 1);
	const handleBack = () => setActiveStep((prev) => prev - 1);

	const renderStepContent = (step) => {
		switch (step) {
			case 0:
				return <MasterGeneralInformation value={value} setValue={setValue} />;
			case 1:
				return <ApplicableDate value={value} setValue={setValue} />;
			case 2:
				return <StoreAvailabilitySection value={value} setValue={setValue} />;
			case 3:
				return <DiscountValueSection value={value} setValue={setValue} />;
			case 4:
				return <ProductSelectionSection value={value} setValue={setValue} />;
			default:
				return <Typography>Unknown step</Typography>;
		}
	};

	return (
		<Box width="100%" pt={4}>
			<Stepper activeStep={activeStep} alternativeLabel>
				{steps.map((label) => (
					<Step key={label}>
						<StepLabel>{label}</StepLabel>
					</Step>
				))}
			</Stepper>

			<Box mt={3} display={"flex"} alignItems={"center"} justifyContent={"center"} width={"100%"}>
				{renderStepContent(activeStep)}
			</Box>

			<Stack
				direction="row"
				spacing={2}
				justifyContent="space-between"
				mt={4}
				width={"93vw"}
				position={"fixed"}
				top="85%"
				left="6%">
				<Button disabled={activeStep === 0} onClick={handleBack}>
					Back
				</Button>
				<Button variant="contained" onClick={handleNext} disabled={activeStep === steps.length - 1}>
					Next
				</Button>
			</Stack>
		</Box>
	);
}

export default DiscountMaster;
